// @ts-nocheck
import { Component, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  imports: [CommonModule, RouterModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PagesComponent {
  [key: string]: any;
  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }


}